import { AxisDataAxisPath } from '../../scorecard-mi2/chart/axis-data-axis-path';
import { Legend } from '../models/legend.model';

export function getLegends(data: AxisDataAxisPath[]): Legend[] {
    const legends: Legend[] = [];

    for (const series of data) {
        const { key, points } = series;
        if (points == null || points?.length === 0) {
            return legends;
        }
        const color = points[0].color;

        legends.push({ color, label: key });
    }

    return legends;
}
